import React, { useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";

interface Props {
  show: boolean;
  handleClose: () => void;
}

export const VideoPlayerModal: React.FC<Props> = ({ show, handleClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!show && videoRef.current) {
      videoRef.current.pause();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>How It Works</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <video
          ref={videoRef}
          className="w-100 rounded-bottom"
          controls
          autoPlay
          src="https://www.w3schools.com/html/mov_bbb.mp4"
          style={{ display: "block" }}
        >
          Your browser does not support the video tag.
        </video>
      </Modal.Body>
    </Modal>
  );
};
